/**
 * Application configuration
 */

// API base URL - Updated for production server
export const API_URL = process.env.REACT_APP_API_BASE_URL || 'https://srv857379.hstgr.cloud/api';

// Document types
export const DOCUMENT_TYPES = {
  INVOICE: 'invoice',
  ESTIMATE: 'estimate',
  QUOTE: 'quote'
};

// PDF options
export const PDF_OPTIONS = {
  format: 'A4',
  margin: {
    top: '20mm',
    right: '20mm',
    bottom: '20mm',
    left: '20mm'
  }
};

// Default company information for documents
export const DEFAULT_COMPANY_INFO = {
  name: 'Quality Air Houston',
  address: '6023 Pennworth Ln, Houston, TX 77084',
  phone: '(713) 922-5702',
  email: 'pejmanansaripoor@gmail.com',
  website: 'qualityairhouston.com',
  taxId: 'XX-XXXXXXX' // Replace with actual tax ID
}; 